import React from 'react'
import { LinearProgress } from '@mui/material'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'

const ProgressBar = styled(LinearProgress)`
    &.MuiLinearProgress-root {
        height: 16px;
        border-radius: 14px;
    }
    &.MuiLinearProgress-colorPrimary {
        background-color: ${({ theme }): string => theme.colors.surface.tertiary};
    }
    & .MuiLinearProgress-barColorPrimary {
        background-color: ${({ theme }): string => theme.colors.indicator.skyBlue};
    }
`

const ProgressContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }): string => theme.spacing[200]};
    .progress {
        width: 100%;
    }
`

interface ProgressProps {
    count: number
    total: number
}

const Progress: React.FC<ProgressProps> = ({ count, total }) => {
    const progress = total === 0 ? 0 : (count / total) * 100

    return (
        <ProgressContainer>
            <div className="progress">
                <ProgressBar variant="determinate" value={progress} />
            </div>
            <Text scale="bodyL500" color="primary">
                {`${Math.round(progress)}%`}
            </Text>
        </ProgressContainer>
    )
}

export default Progress
